import { useContext } from 'react'

import { DashboardContext } from '@/providers/DashboardContext'

const useDashboard = () => useContext(DashboardContext)

export default useDashboard
